import { useMutation } from '@tanstack/react-query';

import { videoCallService, type KickParticipantInput } from '../services';

interface KickParticipantMutationInput extends KickParticipantInput {
  sessionId: string;
}

/**
 * Mutation hook for POST /sessions/:id/call/kick. Practitioner +
 * admin only (enforced server-side). Errors surface as isError —
 * backend's 404 indicates session-not-found, not participant-gone
 * (LiveKit's participant-already-left case is wrapped as 500), so
 * there's no 404 carve-out here. Visible participant removal
 * propagates through LiveKit's own event stream — callers don't
 * revert UI state on error.
 */
export function useKickParticipant() {
  return useMutation({
    mutationFn: ({ sessionId, ...input }: KickParticipantMutationInput) =>
      videoCallService.kickParticipant(sessionId, input),
  });
}
